/**
 * Created by jiayanfeng on 2017/11/10.
 * Modified by jiayanfeng on 2019/5/15.
 */
import {combineReducers} from "redux";
import {
	App_Config_Cancel_Quota_Change,
	App_Config_Input_Change, App_Config_Update_Quota,
	Init_App_Config_Page_Data,
	Redirect_To_App_Config_Page,
	Update_App_Config_Page_Data
} from "./AppConfigAndConditionConstants";

function guid(state = "", action) {
	switch (action.type)
	{
		case Redirect_To_App_Config_Page:
			return action.data;
		default:
			return state;
	}
}

function name(state = "", action) {
	switch (action.type)
	{
		case Update_App_Config_Page_Data:
			return action.data.name;
		default:
			return state;
	}
}

function applicationState(state = "", action) {
	switch (action.type)
	{
		case Update_App_Config_Page_Data:
			return action.data.status;
		default:
			return state;
	}
}


function quota(state = {
  cpu: 0,
	memory:0,
  diskQuota:0,
}, action) {
	switch (action.type)
	{
		case Update_App_Config_Page_Data:
			return {
        cpu: action.data.cpuLimit,
			  memory:action.data.memoryLimit,
        diskQuota:action.data.diskLimit,
			};
		default:
			return state;
	}
}

function unit(state = {
  cpu: "",
  memory: "",
  disk: "",
}, action) {
  switch (action.type)
  {
    case Update_App_Config_Page_Data:
      return {
        cpu: action.data.cpuUnit,
        memory:action.data.memoryUnit,
        disk:action.data.diskUnit,
      };
    default:
      return state;
  }
}

function appStatistics(state = {
  cpu:0,
  memory:0,
  disk:0
}, action) {
	switch (action.type)
	{
		case Update_App_Config_Page_Data:
		    return {
          cpu:action.data.cpuUsed,
          memory: action.data.memoryUsed,
          disk: action.data.diskUsed
        };
		default:
			return state;
	}
}


const AppConfigAndConditionReducer = combineReducers({guid,name,applicationState,
  quota,unit,appStatistics
});




export default  AppConfigAndConditionReducer;
